module.exports = __webpack_public_path__ + "static/media/local-designs-horizontal.67a2308b.svg";